import textAreaComponent from './textArea.component';

const textAreaModule = angular.module('app.common.textArea', [])
	.component('ertTextArea', textAreaComponent)
	.name;

export default textAreaModule;
